import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import DashboardKeys from 'src/constants/locale/key/Dashboard'

const DashboardTranslationText = () => {

    const { translate } = useTranslation([
        Namespace.UI_COMPONENT,
        Namespace.DASHBOARD
    ])
    //ehbl
    let ehblManifestTitle = translate(Namespace.DASHBOARD, DashboardKeys.EHBL_MANIFEST_TITLE)
    let ehblManifestBySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.EHBL_MANIFEST_BY_SUBMITTED_DATE_TITLE)
    let primaryCCN = translate(Namespace.DASHBOARD, DashboardKeys.PRIMARY_CCN)
    let status = translate(Namespace.DASHBOARD, DashboardKeys.STATUS)
    let portOfDischarge = translate(Namespace.DASHBOARD, DashboardKeys.PORT_OF_DISCHARGE)
    let portOfDestinationExit = translate(Namespace.DASHBOARD, DashboardKeys.PORT_OF_DESTINATION_EXIT)
    let hblStatusReleased = translate(Namespace.DASHBOARD, DashboardKeys.HBL_STATUS_RELEASED)
    let masterReferenceNumber = translate(Namespace.DASHBOARD, DashboardKeys.MASTER_REFERENCE_NUMBER)

    //isf 10
    let isf10Title = translate(Namespace.DASHBOARD, DashboardKeys.ISF10_TITLE)
    let isf10BySubmittedDateTitle = translate(Namespace.DASHBOARD, DashboardKeys.ISF10_BY_SUBMITTED_DATE_TITLE)
    let transactionId = translate(Namespace.DASHBOARD, DashboardKeys.TRANSACTION_ID)
    let importerDocumentNumber = translate(Namespace.DASHBOARD, DashboardKeys.IMPORTER_DOCUMENT_NUMBER)
    let shipmentReferenceNumber = translate(Namespace.DASHBOARD, DashboardKeys.SHIPMENT_REFERENCE_NUMBER)
    let referenceBookingNumber = translate(Namespace.DASHBOARD, DashboardKeys.REFERENCE_BOOKING_NUMBER)
    let seeAllRecords = translate(Namespace.DASHBOARD, DashboardKeys.SEE_ALL_RECORDS)

    //status
    let draft = translate(Namespace.DASHBOARD, DashboardKeys.DRAFT)
    let accepted = translate(Namespace.DASHBOARD, DashboardKeys.ACCEPTED)
    let sent = translate(Namespace.DASHBOARD, DashboardKeys.SENT)
    let rejected = translate(Namespace.DASHBOARD, DashboardKeys.REJECTED)
    let statusNotification = translate(Namespace.DASHBOARD, DashboardKeys.STATUS_NOTIFICATION)
    let cancellationAccepted = translate(Namespace.DASHBOARD, DashboardKeys.CANCELLATION_ACCEPTED)
    let cancellationRejected = translate(Namespace.DASHBOARD, DashboardKeys.CANCELLATION_REJECTED)
    let modificationRejected = translate(Namespace.DASHBOARD, DashboardKeys.MODIFICATION_REJECTED)

    return {
        ehblManifestTitle,
        ehblManifestBySubmittedDateTitle,
        primaryCCN,
        status,
        portOfDischarge,
        portOfDestinationExit,
        hblStatusReleased,
        masterReferenceNumber,
        draft,
        accepted,
        sent,
        rejected,
        statusNotification,
        cancellationAccepted,
        cancellationRejected,
        modificationRejected,
        isf10Title,
        isf10BySubmittedDateTitle,
        transactionId,
        importerDocumentNumber,
        shipmentReferenceNumber,
        referenceBookingNumber,
        seeAllRecords
    }
    
}

export default DashboardTranslationText